var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.count),function(x){return _c('v-row',{key:x},[_c('v-col')],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }